/* eslint-disable max-lines-per-function */
/* eslint-disable react/prop-types */
import { MuiThemeProvider } from '@material-ui/core/styles';
import { ListAdvisors } from 'containers/Advisors';
import {
  ConfigureMFA,
  ForgotPassword,
  RegisterPassword,
  UserLogin,
  TrustedLogin,
} from 'containers/Authenticate';
import {
  AccessRestrictionsClients,
  AddClient,
  ApplicationsClients,
  AuditClients,
  ClientConfigurations,
  ListClients,
  ListUsers,
  MaintenanceClients,
  SessionClients,
  SimulateApp,
  SimulateConnectSky,
  SimulateRdp,
  SimulateRemoteApp,
  SimulateRemoteAppInstall,
} from 'containers/Clients';
import { EditCompany } from 'containers/Companies';
import {
  Configuration,
  EnvironmentsList,
  InstancesList,
  MaintenanceEnvironments,
  NewEnvironments,
  HistoryEnvironment,
  PerformanceEnvironment,
  SessionsEnvironment,
} from 'containers/Environments';
import { EditGroup, ListGroups } from 'containers/Groups';
import NotPermission from 'containers/NotPermission';
import { EditOperator, NewOperator, OperatorsList } from 'containers/Operators';
import { UsersList } from 'containers/Users';
import { AllCompaniesList } from 'containers/OperatorView/Companies';
import ListAllEnvironments from 'containers/OperatorView/Environments/ListAllEnvironments';
import ListAllClients from 'containers/OperatorView/ListAllClients';
import { AllPartnersList } from 'containers/OperatorView/Partners';
import {
  AdministrationPanel,
  ClientsPanel,
  CostsPanel,
  EnvironmentsPanel,
  IncidentsPanel,
} from 'containers/Panel';
import {
  NewPartner,
  PartnersList,
  CustomPartnerFront,
  Configurations,
  PartnerServers,
  CustomFront,
  LeakedCredentials,
} from 'containers/Partners';
import ListAllLogs from 'containers/Logs/ListAllLogs';

import React, { lazy, Suspense } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import theme from 'theme/index';
import {
  ListAllUsers,
  ListUsersForRecovery,
  UsersManagement,
} from 'containers/OperatorView/ListAllUsers';
import { isClientOperator } from 'utils/role';
import Servers from 'containers/Environments/Servers';
import { RolesEnum } from 'modules/authenticate/interfaces';
import ListInstanceByUsage from 'containers/Partners/ListInstanceByUsage';
import DigitalCertificates from 'containers/Clients/DigitalCertificates';
import i18n from 'i18n';
import PrivateRoute from './PrivateRoute';

const NotFound = lazy(() => import('containers/NotFound'));

const Router = ({ path, role }) => {
  return (
    <React.Fragment>
      <div
        style={{
          height: '100vh',
          overflow:
            path.includes('credit') || path.includes('perfil') ? '' : 'hidden',
        }}
      >
        <MuiThemeProvider theme={theme}>
          <Suspense fallback={<div>{i18n.t('LOADING_KEY')}...</div>}>
            <Switch>
              <Route path="/" component={UserLogin} exact />
              <Route path="/trustedLogin" component={TrustedLogin} exact />
              <Route path="/forgotPassword" component={ForgotPassword} />
              <Route
                path="/registerPassword/:token"
                component={RegisterPassword}
              />
              <PrivateRoute
                path="/authenticate/mfa"
                component={ConfigureMFA}
                noTemplate
                exact
              />

              <PrivateRoute
                path="/notPermission"
                component={NotPermission}
                exact
              />

              <PrivateRoute
                permission="list_company_dashboard"
                component={EnvironmentsPanel}
                path="/dashboard/company"
                exact
              />
              <PrivateRoute
                permission="list_partner_dashboard"
                component={ClientsPanel}
                path="/dashboard/partner"
                exact
              />
              <PrivateRoute
                component={IncidentsPanel}
                path="/dashboard/incidents/:section?"
                exact
              />
              <PrivateRoute
                permission="list_environment_cost"
                component={CostsPanel}
                path="/dashboard/costs"
                exact
              />
              <PrivateRoute
                component={AdministrationPanel}
                path="/administrationPanel"
                exact
              />

              <PrivateRoute
                permission="list_all_operators"
                component={OperatorsList}
                path="/operators"
                exact
              />
              <PrivateRoute
                permission="create_new_operator"
                component={NewOperator}
                path="/operators/new"
                exact
              />
              <PrivateRoute
                component={EditOperator}
                path="/operators/:id/edit"
                exact
              />
              <PrivateRoute
                permission="list_company_details"
                component={EditCompany}
                path="/companies/:id/edit"
                exact
              />

              <PrivateRoute
                permission="list_all_partners"
                component={PartnersList}
                path="/partners"
                exact
              />
              <PrivateRoute
                permission="create_new_partner"
                component={NewPartner}
                path="/partners/new"
                exact
              />
              <PrivateRoute
                component={CustomPartnerFront}
                path="/partners/custom/front/:id"
                exact
              />

              <PrivateRoute
                permission="list_environment"
                component={EnvironmentsList}
                path="/environments"
                exact
              />
              <PrivateRoute
                permission="create_new_environment"
                component={NewEnvironments}
                path="/environments/new"
                exact
              />
              <PrivateRoute
                permission="list_environment_instances"
                component={InstancesList}
                path="/environments/:id/instances/:search?"
                exact
              />
              <PrivateRoute
                component={Servers}
                path="/environments/:id/servers"
                exact
              />
              <PrivateRoute
                component={Configuration}
                path="/environments/:id/configuration/:section?/:uuid?"
                exact
              />
              <PrivateRoute
                permission="list_environment_instance_sessions"
                component={SessionsEnvironment}
                path="/environments/:id/sessions"
                exact
              />
              {!isClientOperator(role) && (
                <PrivateRoute
                  component={HistoryEnvironment}
                  path="/environments/:id/history"
                  exact
                />
              )}
              <PrivateRoute
                component={MaintenanceEnvironments}
                path="/environments/:id/maintenance"
                exact
              />
              <PrivateRoute
                component={PerformanceEnvironment}
                path="/environments/:id/performance/:section?"
                exact
              />

              <PrivateRoute
                permission="list_client"
                component={ListClients}
                path="/clients/"
                exact
              />
              <PrivateRoute
                permission="create_new_client"
                component={AddClient}
                path="/clients/new"
                exact
              />
              <PrivateRoute
                permission="edit_client"
                component={ClientConfigurations}
                path="/clients/:id/configurations"
                exact
              />
              <PrivateRoute
                component={MaintenanceClients}
                path="/clients/:id/maintenance"
                exact
              />
              <PrivateRoute
                component={ApplicationsClients}
                path="/clients/:id/applications"
                exact
              />
              <Route
                path="/clients/applications/simulate"
                exact
                component={SimulateApp}
              />
              <Route
                path="/clients/applications/simulate/connectSky"
                exact
                component={SimulateConnectSky}
              />
              <Route
                path="/clients/applications/simulate/remoteapp"
                exact
                component={SimulateRemoteApp}
              />
              <Route
                path="/clients/applications/simulate/rdp/file"
                exact
                component={SimulateRdp}
              />

              <Route
                path="/clients/applications/simulate/remoteapp/install"
                exact
                component={SimulateRemoteAppInstall}
              />
              <PrivateRoute
                component={SessionClients}
                path="/clients/:id/sessions"
                exact
              />
              <PrivateRoute
                permission="list_users"
                component={ListUsers}
                path="/clients/:id/users"
                exact
              />
              <PrivateRoute
                permission="client_access_control"
                component={AccessRestrictionsClients}
                path="/clients/:id/access-restrictions"
                exact
              />
              <PrivateRoute
                permission="list_all_operators_audit_logs"
                component={AuditClients}
                path="/clients/:id/audit"
                exact
              />
              <PrivateRoute
                permission="list_client_certificates"
                component={DigitalCertificates}
                path="/clients/:id/digital-certificates"
                exact
              />
              <PrivateRoute
                permission="edit_partner_details"
                component={Configurations}
                path="/partners/:id/configuration"
                exact
              />
              <PrivateRoute
                permission="list_partner_servers"
                component={PartnerServers}
                path="/partners/:id/servers"
                exact
              />
              <PrivateRoute
                permission="list_partner_instances"
                component={ListInstanceByUsage}
                path="/partners/:id/instances"
                exact
              />
              <PrivateRoute
                permission="edit_user_theme_config"
                component={CustomFront}
                path="/partners/:id/custom-front"
                exact
              />
              <PrivateRoute component={ListGroups} path="/groups" exact />
              <PrivateRoute
                component={EditGroup}
                path="/groups/:role_uuid"
                exact
              />

              <PrivateRoute
                permission="list_scaling_advisors"
                component={ListAdvisors}
                path="/dashboard/advisors"
                exact
              />

              <PrivateRoute
                permission="list_all_companies"
                component={AllCompaniesList}
                path="/all-companies"
                exact
              />
              <PrivateRoute
                permission="list_all_companies"
                component={AllPartnersList}
                path="/all-partners"
                exact
              />
              <PrivateRoute
                permission="list_all_companies"
                component={ListAllEnvironments}
                path="/all-environments"
                exact
              />
              <PrivateRoute
                permission="list_all_companies"
                component={ListAllClients}
                path="/all-clients"
                exact
              />
              <PrivateRoute
                permission="list_all_users"
                component={ListAllUsers}
                path="/all-users"
                exact
              />
              {role === RolesEnum.superAdmin && (
                <PrivateRoute
                  component={UsersManagement}
                  path="/all-users/management"
                  exact
                />
              )}
              <PrivateRoute
                permission="users_recovery"
                component={ListUsersForRecovery}
                path="/all-users/recovery"
                exact
              />
              <PrivateRoute
                permission="list_all_operators_audit_logs"
                path="/audit"
                exact
                component={ListAllLogs}
              />
              <PrivateRoute
                permission="list_leaked_credentials"
                component={LeakedCredentials}
                path="/leaked-credentials"
                exact
              />
              <PrivateRoute
                permission="list_all_users"
                component={UsersList}
                path="/users"
                exact
              />
              <Route path="/404" component={NotFound} />
              <Redirect to="/404" />
            </Switch>
          </Suspense>
        </MuiThemeProvider>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({ router, authenticate: { data } }) => ({
  path: router.location.pathname,
  role: data?.role,
});

export default withTranslation()(connect(mapStateToProps)(Router));
